export class DateHelper {
    public static convertToWorkTimer(date?: Date) {
        return date?.toTimeString().split(" ")[0].substring(0, 5);
    }
}
